export class ProformaReqTypeAddError extends Error {
	readonly formName?: string;

	constructor(message?: string, formName?: string) {
		super(message);
		this.formName = formName;
	}

	readonly proformaReqTypeAddErrorTag = true;
}
